import { useNavigate } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { useI18n } from "@/i18n";

/**
 * Modal shown when a free-plan user hits a plan limit.
 *
 * Props:
 * - open: boolean
 * - onClose: () => void
 * - limit: number — the numeric limit reached (5, 3, 1, etc.)
 * - item: string — translated short item name ("items en el cofre", "mensajes", "herederos")
 *
 * Triggered by catching HTTP 403 with code "PLAN_LIMIT_EXCEEDED".
 */
export default function PlanLimitModal({ open, onClose, limit, item }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  if (!open) return null;
  const goToPlans = () => {
    onClose?.();
    navigate("/plans");
  };
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
      data-testid="plan-limit-modal"
      onClick={onClose}
    >
      <div
        className="glass-card rounded-md max-w-md w-full p-6 sm:p-8 border-2 border-gold gold-glow relative"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "linear-gradient(135deg, rgba(201,163,106,0.10), rgba(13,12,11,0.95))",
        }}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-faded hover:text-gold-light p-1"
          aria-label={t("payment_dismiss")}
          data-testid="plan-limit-close"
        >
          <X className="w-4 h-4" />
        </button>
        <Sparkles className="w-8 h-8 text-gold mb-4" strokeWidth={1.3} />
        <h3 className="font-display text-2xl text-gold-light mb-3">{t("upgrade_modal_title")}</h3>
        <p className="text-sm text-muted leading-relaxed mb-6">
          {t("upgrade_modal_body").replace("{LIMIT}", String(limit ?? "")).replace("{ITEM}", item ?? "")}
        </p>
        <div className="flex flex-col-reverse sm:flex-row gap-2 sm:gap-3 justify-end">
          <button onClick={onClose} className="btn-ghost text-sm" data-testid="plan-limit-dismiss">
            {t("upgrade_modal_dismiss")}
          </button>
          <button onClick={goToPlans} className="btn-gold text-sm" data-testid="plan-limit-cta">
            {t("upgrade_modal_cta")}
          </button>
        </div>
      </div>
    </div>
  );
}
